import { UPLOAD_TIMEOUT_MS } from '../../../../config/consts/commons';
import { apiInstances } from '../../../../libs';
import env from '../../../../config/env';

const { post } = apiInstances.storageInstance;

export default async function uploadOrderToReturnPhoto({ id_order, formData }) {
  return post(`/clouders/orders/${id_order}/returnPickupPoint`, formData, {
    timeout: Number(env.UPLOAD_TIMEOUT_MS) || UPLOAD_TIMEOUT_MS,
  });
}
